import { isToday } from 'date-fns';

import { getRoundedPercentageOfValue, getRoundedValueOfPercentage } from '@sg/garnish';

import { ignoreTimezone } from '@order/utils';

import { getMaxTipAmount } from '../utils/tipping';
import { type OrderingLedger, type WantedTime } from './ordering-machine.types';

export const isWantedTimeToday = (time?: WantedTime) => {
  const validTime = time?.time ? ignoreTimezone(time.time) : null;

  return Boolean(validTime && isToday(validTime));
};

export const getNewTip = (
  previousTip: number,
  previousMaxTipAmount: number,
  availableTips: ReadonlyArray<number | 'CUSTOM'>,
  newLedger?: OrderingLedger,
): number => {
  const previousPercentage = getRoundedPercentageOfValue(previousTip, previousMaxTipAmount);

  if (availableTips.includes(previousPercentage)) {
    const newMaximumTip = getMaxTipAmount(newLedger);
    return getRoundedValueOfPercentage(previousPercentage, newMaximumTip) || 0;
  }

  const newMaximumTip = getMaxTipAmount(newLedger);
  if (previousTip > newMaximumTip) {
    return newMaximumTip;
  }

  return previousTip;
};
